import React from "react";
import * as styles from "./TextSectionCafetera.module.scss";
import { motion } from "framer-motion";

const TextSectionCafetera = () => {
  return (
    <motion.section
      whileInView={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      transition={{ duration: 0 }}
      className={styles.section2}
    >
      <motion.div className={styles.main_container}>
        <motion.h2
          whileInView={{ y: 0 }}
          initial={{ y: 100 }}
          transition={{ duration: 0.3 }}
        >
          Dale un toque especial a tus desayunos o regalate 
        </motion.h2>
        <motion.h2
          whileInView={{ y: 0 }}
          initial={{ y: 100 }}
          transition={{ duration: 0.4 }}
        >
          un momento de disfrute a cualquier hora del día 
        </motion.h2>

        <motion.h2
          whileInView={{ y: 0 }}
          initial={{ y: 100 }}
          transition={{ duration: 0.5 }}
        >
         con los cafés más exquisitos. Prepará en minutos 
        </motion.h2>
        <motion.h2
          whileInView={{ y: 0 }}
          initial={{ y: 100 }}
          transition={{ duration: 0.6 }}
        >
          un Espresso, Capuccino o Latte con un cuerpo y 
        </motion.h2>
        <motion.h2
          whileInView={{ y: 0 }}
          initial={{ y: 100 }}
          transition={{ duration: 0.7 }}
        >
          aroma únicos. ¡Como en las mejores cafeterías!
        </motion.h2>
      </motion.div>
    </motion.section>
  );
};

export default TextSectionCafetera;
